import { Component, Input } from '@angular/core';

type LoaderSize = 'small' | 'mid' | 'large';
type LoaderColor = 'primary' | 'grey' | 'light';

@Component({
  selector: 'fl-spinner',
  template: `
    <div
      class="Spinner"
      role="presentation"
      [attr.data-size]="size"
      [attr.data-hasBackground]="attrHasBackground"
      [attr.data-color]="color">
    </div>
  `,
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  attrHasBackground: true | undefined;

  @Input() size: LoaderSize = 'mid';
  @Input()
  set hasBackground(value: boolean) {
    this.attrHasBackground = value ? true : undefined;
  }
  @Input() color: LoaderColor = 'primary';
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/spinner/spinner.component.ts